// Siehe Fehler: https://thaliamayersche.atlassian.net/browse/WDD-1491
// https://docs.usercentrics.com/#/consent-mode?id=step-2-optional-use-the-usercentrics-cmp-events-to-signal-the-consent-status-via-the-consent-mode-api-for-custom-data-processing-services
import { processConsentUpdate } from "./ucConsentManager.js";

const UC_ANALYTICS_DPS_NAME = "Google Analytics";
const UC_ADS_DPS_NAME = "Google Ads";

/**
 * Event-Handler für Usercentrics consent_status Events (Web/Browser)
 * Nutzt DPS-Namen aus event.detail
 * @param {CustomEvent} event - Usercentrics Event mit detail.event === "consent_status"
 */
export function ucEventHandler(event) {
	if (!event.detail) return;
	const { detail } = event;
	if (detail["event"] !== "consent_status") return;

	const adsExists = detail.hasOwnProperty(UC_ADS_DPS_NAME);
	const analyticsExists = detail.hasOwnProperty(UC_ANALYTICS_DPS_NAME);
	const adsGranted = detail[UC_ADS_DPS_NAME];
	const analyticsGranted = detail[UC_ANALYTICS_DPS_NAME];

	processConsentUpdate({
		adsGranted,
		analyticsGranted,
		adsExists,
		analyticsExists,
		eventType: detail["type"]
	});
}
